export enum LangAbbreviation {
  Polish = 'pl',
  English = 'en',
}

export interface TermsOfUse {
  pl: string;
  en: string;
}
